export const MaximumMaterialsLimit = 350

export const OldModelSpreadsheetUrl =
  'https://drive.google.com/drive/folders/1uoWdlZgen-CKGlUty8VsszCjyuyAAsYp?usp=sharing'
export const ModelSpreadsheetUrl =
  'https://docs.google.com/spreadsheets/d/1HS0oKtjl0tVVRUx5CUdoGNUB_961_n2n/edit?usp=drive_web&ouid=117727617176020336301&rtpof=true'
